import Header from "./TentangKami/Header";
import Deskripsi from "./TentangKami/Deskripsi";
import DireksiKomisaris from "./TentangKami/DireksiKomisaris";
import LaporanKeuangan from "./TentangKami/LaporanKeuangan";
import PemegangSaham from "./TentangKami/PemegangSaham";

function Index() {
    return (
        <div className={"h-screen"}>
            <Header />
            <Deskripsi />
            <DireksiKomisaris/>
            <PemegangSaham/>
            <LaporanKeuangan/>
        </div>
    );
}

export default Index;
